
import CONSTANT from '../constant/search'
import service from '../service/search'
import { historyStorageFun } from '../util/function'
import Progress from '../lib/progress'

const historyStorage = historyStorageFun()

export default {
  getSearchHistory({ commit }) {
    return new Promise((resolve, reject) => {
      const historyList = historyStorage.get()
      commit(CONSTANT.SEARCH_GET_HISTORY_SUCCESS, historyList)
      resolve(historyList)
    })
  },
  setSearchHistory({ commit }, data) {
    return new Promise((resolve, reject) => {
      let historyList = historyStorage.get()
      historyList = historyList.filter(item => item !== data)
      if (historyList.length >= CONSTANT.SEARCH_MAX_HISTORY) {
        historyList.pop()
      }
      historyList.unshift(data)
      historyStorage.set(historyList)
      commit(CONSTANT.SEARCH_SET_HISTORY_SUCCESS, historyList)
      resolve(historyList)
    })
  },
  clearSearchHistory({ commit }) {
    return new Promise((resolve, reject) => {
      const result = historyStorage.clear()
      commit(CONSTANT.SEARCH_CLEAR_HISTORY_SUCCESS)
      resolve(result)
    })
  },
  removeSearchHistory({ commit }, data) {
    return new Promise((resolve, reject) => {
      let historyList = historyStorage.get()
      historyList = historyList.filter(item => item !== data)
      historyStorage.set(historyList)
      commit(CONSTANT.SEARCH_REMOVE_HISTORY_SUCCESS, historyList)
      resolve(historyList)
    })
  },
  getSearchResult({ commit }, data) {
    return new Promise((resolve, reject) => {
      Progress.start()
      return service.getSearchResult(data).then(result => {
        Progress.done()
        commit(CONSTANT.SEARCH_GET_RESULT_SUCCESS, result)
        resolve(result)
      }, e => {
        Progress.done()
        commit(CONSTANT.SEARCH_GET_RESULT_ERROR, e)
        reject(e)
      })
    })
  },
  getSearchResultMore({ commit }, data) {
    return new Promise((resolve, reject) => {
      return service.getSearchResult(data).then(result => {
        commit(CONSTANT.SEARCH_GET_RESULT_MORE_SUCCESS, result)
        resolve(result)
      }, e => {
        commit(CONSTANT.SEARCH_GET_RESULT_MORE_ERROR, e)
        reject(e)
      })
    })
  },
  getSearchResultV2({ commit }, data) {
    return new Promise((resolve, reject) => {
      Progress.start()
      return service.getSearchResultV2(data).then(result => {
        Progress.done()
        commit(CONSTANT.SEARCH_GET_RESULT_SUCCESS_V2, result)
        resolve(result)
      }, e => {
        Progress.done()
        commit(CONSTANT.SEARCH_GET_RESULT_ERROR_V2, e)
        reject(e)
      })
    })
  },
  getSearchResultMoreV2({ commit }, data) {
    return new Promise((resolve, reject) => {
      return service.getSearchResultV2(data).then(result => {
        commit(CONSTANT.SEARCH_GET_RESULT_MORE_SUCCESS_V2, result)
        resolve(result)
      }, e => {
        commit(CONSTANT.SEARCH_GET_RESULT_MORE_ERROR_V2, e)
        reject(e)
      })
    })
  },
  getSearchResultV3({ commit }, data) {
    return new Promise((resolve, reject) => {
      Progress.start()
      return service.getSearchResultV3(data).then(result => {
        Progress.done()
        commit(CONSTANT.SEARCH_GET_RESULT_SUCCESS_V3, result)
        resolve(result)
      }, e => {
        Progress.done()
        commit(CONSTANT.SEARCH_GET_RESULT_ERROR_V3, e)
        reject(e)
      })
    })
  },
  getSearchResultMoreV3({ commit }, data) {
    return new Promise((resolve, reject) => {
      return service.getSearchResultV3(data).then(result => {
        commit(CONSTANT.SEARCH_GET_RESULT_MORE_SUCCESS_V3, result)
        resolve(result)
      }, e => {
        commit(CONSTANT.SEARCH_GET_RESULT_MORE_ERROR_V3, e)
        reject(e)
      })
    })
  },
  getSearchHotWords({ commit }, data) {
    return new Promise((resolve, reject) => {
      return service.getSearchHotWords(data).then(result => {
        commit(CONSTANT.SEARCH_GET_HOT_WORDS_SUCCESS, result)
        resolve(result)
      }, e => {
        commit(CONSTANT.SEARCH_GET_HOT_WORDS_ERROR, e)
        reject(e)
      })
    })
  },
  getProductBySearch({ commit }, data) {
    return new Promise((resolve, reject) => {
      return service.getProductBySearch(data).then(result => {
        commit(CONSTANT.SEARCH_GET_RECOMMEND_PRODUCT_SUCCESS, result)
        resolve(result)
      }, e => {
        commit(CONSTANT.SEARCH_GET_RECOMMEND_PRODUCT_ERROR, e)
        reject(e)
      })
    })
  },
  getProductMoreBySearch({ commit }, data) {
    return new Promise((resolve, reject) => {
      return service.getProductBySearch(data).then(result => {
        commit(CONSTANT.SEARCH_GET_RECOMMEND_PRODUCT_MORE_SUCCESS, result)
        resolve(result)
      }, e => {
        reject(e)
      })
    })
  },
  getShadingHotKeywords({ state, commit }, data) {
    return new Promise((resolve, reject) => {
      return service.getShadingHotKeywords(data).then(result => {
        commit(CONSTANT.SEARCH_GET_SHADING_HOTWORDS_SUCCESS, result)
        resolve(result)
      }, e => {
        reject(e)
      })
    })
  }
}
